export const icons = {
    sm: '12px',
    md: '18px',
    lg: '24px',
};
export default icons;
